import React, { useState, useMemo } from 'react';
import styles from './DispatchTable.module.css';
import * as XLSX from 'xlsx';

const formatCurrency = (amount) =>
  '₹' + (amount || 0).toLocaleString('en-IN');

const DispatchTable = ({ lineItems = [], invoiceNo,onDownloadCoa  }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [isExporting, setIsExporting] = useState(false);

  const filtered = useMemo(() => {
    if (!searchTerm.trim()) return lineItems;
    const lower = searchTerm.toLowerCase();
    return lineItems.filter(item =>
      item.itemNo?.toLowerCase().includes(lower) ||
      item.itemDescription?.toLowerCase().includes(lower) ||
      item.casNo?.toLowerCase().includes(lower)
    );
  }, [lineItems, searchTerm]);

  const handleExportExcel = () => {
    setIsExporting(true);
    try {
      const rows = filtered.map((item, i) => ({
        'No.': i + 1,
        'Item No.': item.itemNo || '-',
        'Description': item.itemDescription || '-',
        'CAS No.': item.casNo || '-',
        'Unit': item.unit || '-',
        'Pack Size': item.packSize || '-',
        'Unit Sales Price': item.unitSalesPrice || '-',
        'QTY': item.qty || '-',
        'Total Sales Price': item.totalSalesPrice || '-',
      }));
      const ws = XLSX.utils.json_to_sheet(rows);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Dispatch Details');
      XLSX.writeFile(wb, `Dispatch_${invoiceNo || 'Details'}.xlsx`);
    } catch (e) {
      alert('Export failed');
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <div className={styles.card}>
      <div className={styles.cardHeader}>
        <h5>Items Shipped</h5>
        <div className={styles.headerActions}>
          <input
            type="text"
            placeholder="Search items..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className={styles.searchInput}
          />
          <button
            onClick={handleExportExcel}
            disabled={isExporting || lineItems.length === 0}
            className={styles.exportBtn}
          >
            {isExporting ? 'Exporting...' : '📊 Export Excel'}
          </button>
        </div>
      </div>

      <div className={styles.tableWrapper}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>No.</th>
              <th>Item No.</th>
              <th>Description</th>
              <th>CAS No.</th>
              <th>Unit</th>
              <th>Pack Size</th>
              <th>Unit Sales Price</th>
              <th>QTY</th>
              <th>Total Sales Price</th>
              <th>COA</th>
            </tr>
          </thead>
          <tbody>
            {filtered.length === 0 ? (
              <tr>
                <td colSpan={10} className={styles.emptyRow}>
                  No items found
                </td>
              </tr>
            ) : (
              filtered.map((item, i) => (
                <tr key={i}>
                  <td>{i + 1}</td>
                  <td>{item.itemNo || '-'}</td>
                  <td className={styles.descCell}>{item.itemDescription || '-'}</td>
                  <td>{item.casNo || '-'}</td>
                  <td>{item.unit || '-'}</td>
                  <td>{item.packSize || '-'}</td>
                  <td>{formatCurrency(item.unitSalesPrice)}</td>
                  <td>{item.qty || '-'}</td>
                  <td>{formatCurrency(item.totalSalesPrice)}</td>
                  <td>
                    {item.coaSource && item.coaSource !== 'NONE' ? (
                      <button
                        className={styles.coaBtn}
                        onClick={() => onDownloadCoa(item)}
                      >
                        COA
                      </button>
                    ) : (
                      <span className={styles.naText}>N/A</span>
                    )}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DispatchTable;